import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { FormikFormGroup } from "components/common";
const DEFAULT_SPOOL_DIRECTORY = "/tmp/graylog-archive-spool";
const ArchiveBackendGCSFieldGroup = ({ enableSpool = true }) => {
  const { t } = useTranslation("enterprise_archive");
  const {
    values: { id },
    setFieldValue
  } = useFormikContext();
  useEffect(() => {
    if (!id) {
      if (enableSpool) {
        setFieldValue("settings.spool_directory", DEFAULT_SPOOL_DIRECTORY);
      }
      setFieldValue("settings.output_path", "");
    }
  }, [enableSpool, setFieldValue, id]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "settings.bucket",
      type: "text",
      label: t("archive_backend_gcs_field_group.bucket_label"),
      help: t("archive_backend_gcs_field_group.bucket_help"),
      labelClassName: "",
      required: true,
      wrapperClassName: ""
    }
  ), /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "settings.project_id",
      type: "text",
      label: t("archive_backend_gcs_field_group.project_id_label"),
      help: t("archive_backend_gcs_field_group.project_id_help"),
      labelClassName: "",
      wrapperClassName: ""
    }
  ), /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "settings.endpoint_uri",
      type: "text",
      label: t("archive_backend_gcs_field_group.endpoint_uri_label"),
      help: t("archive_backend_gcs_field_group.endpoint_uri_help"),
      labelClassName: "",
      wrapperClassName: ""
    }
  ), enableSpool && /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "settings.spool_directory",
      type: "text",
      label: t("archive_backend_gcs_field_group.spool_directory_label"),
      help: t("archive_backend_gcs_field_group.spool_directory_help"),
      labelClassName: "",
      required: true,
      wrapperClassName: ""
    }
  ));
};
export default ArchiveBackendGCSFieldGroup;
